var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.url,"allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }